/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Nucleus Admin API
 * Headless, multi-tenant commerce backend for jewelry brands.
 *
 * ## Surfaces
 *
 * | Prefix | Caller | Credential |
 * |---|---|---|
 * | `/platform/v1` | Platform operator | Platform token from **Platform: Auth** |
 * | `/admin/v1` | Staff of one organization | Staff token from **Admin: Auth** |
 * | `/storefront/v1` | A storefront | Store API key from **Admin: API keys** |
 * | `/public/v1` | Anyone (the brand application form) | None; rate limited per IP |
 *
 * Every credential is sent as `Authorization: Bearer <value>`. Use the **Authorize** button once and it applies to every request you try here.
 *
 * ## Conventions
 *
 * - **Ids** are UUID v7 strings. **Timestamps** are ISO 8601 in UTC. **Money** is `{ amount, currency }` with `amount` in integer minor units.
 * - **Lists** paginate by cursor: `?limit=20&cursor=...` in, `{ items, nextCursor }` out, `nextCursor` is `null` on the last page.
 * - **Errors** always use one envelope, `{ error: { code, message, requestId, details?, meta? } }`. Switch on `code`, never on `message`.
 * - **Request ids**: every response carries `x-request-id`. Quote it when reporting a problem.
 * - **Idempotency**: endpoints that create money-related state require an `Idempotency-Key` header; the header is listed on those endpoints.
 * - A record that belongs to another tenant answers **404**, never 403, so existence is not leaked.
 * OpenAPI spec version: 0.1.0
 */
import type {
  DeleteAdminV1StoresStoreIdTaxRatesIdPathParameters,
  GetAdminV1StoresStoreIdTaxRates200,
  GetAdminV1StoresStoreIdTaxRatesPathParameters,
  PatchAdminV1StoresStoreIdTaxRatesIdBody,
  PatchAdminV1StoresStoreIdTaxRatesIdPathParameters,
  PostAdminV1StoresStoreIdTaxRatesBody,
  PostAdminV1StoresStoreIdTaxRatesPathParameters,
  TaxRate
} from '../model';

import { customInstance } from '../../../transport/mutator';
import type { BodyType } from '../../../transport/mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Applied at checkout only while settings.tax.provider is manual; all rates matching the shipping address add up
 * @summary Tax rates of the store, by priority
 */
export const getAdminV1StoresStoreIdTaxRates = (
    { storeId }: GetAdminV1StoresStoreIdTaxRatesPathParameters,
 options?: SecondParameter<typeof customInstance<GetAdminV1StoresStoreIdTaxRates200>>,) => {
      return customInstance<GetAdminV1StoresStoreIdTaxRates200>(
      {url: `/admin/v1/stores/${storeId}/tax-rates`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Add a tax rate
 */
export const postAdminV1StoresStoreIdTaxRates = (
    { storeId }: PostAdminV1StoresStoreIdTaxRatesPathParameters,
    postAdminV1StoresStoreIdTaxRatesBody: BodyType<PostAdminV1StoresStoreIdTaxRatesBody>,
 options?: SecondParameter<typeof customInstance<TaxRate>>,) => {
      return customInstance<TaxRate>(
      {url: `/admin/v1/stores/${storeId}/tax-rates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminV1StoresStoreIdTaxRatesBody
    },
      options);
    }
  /**
 * @summary Update a tax rate
 */
export const patchAdminV1StoresStoreIdTaxRatesId = (
    { storeId, id }: PatchAdminV1StoresStoreIdTaxRatesIdPathParameters,
    patchAdminV1StoresStoreIdTaxRatesIdBody: BodyType<PatchAdminV1StoresStoreIdTaxRatesIdBody>,
 options?: SecondParameter<typeof customInstance<TaxRate>>,) => {
      return customInstance<TaxRate>(
      {url: `/admin/v1/stores/${storeId}/tax-rates/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchAdminV1StoresStoreIdTaxRatesIdBody
    },
      options);
    }
  /**
 * Orders already placed keep their tax lines
 * @summary Delete a tax rate
 */
export const deleteAdminV1StoresStoreIdTaxRatesId = (
    { storeId, id }: DeleteAdminV1StoresStoreIdTaxRatesIdPathParameters,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/v1/stores/${storeId}/tax-rates/${id}`, method: 'DELETE'
    },
      options);
    }
  export type GetAdminV1StoresStoreIdTaxRatesResult = NonNullable<Awaited<ReturnType<typeof getAdminV1StoresStoreIdTaxRates>>>
export type PostAdminV1StoresStoreIdTaxRatesResult = NonNullable<Awaited<ReturnType<typeof postAdminV1StoresStoreIdTaxRates>>>
export type PatchAdminV1StoresStoreIdTaxRatesIdResult = NonNullable<Awaited<ReturnType<typeof patchAdminV1StoresStoreIdTaxRatesId>>>
export type DeleteAdminV1StoresStoreIdTaxRatesIdResult = NonNullable<Awaited<ReturnType<typeof deleteAdminV1StoresStoreIdTaxRatesId>>>
